import { DialogStyled } from "@/components/DialogStyled";
import theme from "@/styles/theme";
import IosShareIcon from "@mui/icons-material/IosShare";
import { IconButton } from "@mui/material";
import dynamic from "next/dynamic";
import { useState } from "react";

const ModalShareSong = dynamic(() => import("./ModalShareBandOrSong"));

export const ShareSong = ({ song }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpen = () => setIsModalOpen(true);
  const handleModalClosed = () => setIsModalOpen(false);

  return (
    <>
      <IconButton
        onClick={handleOpen}
        aria-label="Song teilen"
        color="secondary"
        sx={{
          borderWidth: "2px",
          borderStyle: "solid",
          borderColor: theme.palette.secondary.main,
          borderRadius: "0",
        }}
      >
        <IosShareIcon sx={{ fontSize: 20 }} />
      </IconButton>
      <DialogStyled
        open={isModalOpen}
        onClose={handleModalClosed}
        disableCloseOnBackgroundClick
        showFullscreen
      >
        <ModalShareSong song={song} />
      </DialogStyled>
    </>
  );
};
